import { render } from "./TabLayout.vue?vue&type=template&id=0169129b&scoped=true&ts=true"
import script from "./TabLayout.vue?vue&type=script&lang=ts"
export * from "./TabLayout.vue?vue&type=script&lang=ts"

import "./TabLayout.vue?vue&type=style&index=0&id=0169129b&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0169129b"]])

export default __exports__